import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=59dc42b8&scoped=true"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"
import style0 from "./BookingTable.vue?vue&type=style&index=0&id=59dc42b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc42b8",
  null
  
)

export default component.exports